<template>
  <mdb-container class="gp-has-header">
    <mdb-row>
      <mdb-col class="text-left" md="12">
        <mdb-card class="text-left mb-4" v-for="(p,i) in docData" v-bind:key="i" v-if="p.location=='FullTop'">
          <mdb-card-body v-html="p.pageText"/>
        </mdb-card>
      </mdb-col>
    </mdb-row>
    <mdb-row>
      <mdb-col class="text-left" md="8">
        <mdb-card class="text-left mb-4" v-for="(p,i) in docData" v-bind:key="i" v-if="p.location=='Left'">
          <mdb-card-body v-html="p.pageText"/>
        </mdb-card>
      </mdb-col>
      <mdb-col class="text-left" md="4">
        <mdb-card class="text-left mb-4" v-for="(p,i) in docData" v-bind:key="i" v-if="p.location=='Right'">
          <mdb-card-body v-html="p.pageText"/>
        </mdb-card>
      </mdb-col>
    </mdb-row>
  </mdb-container>
</template>

<script>
import api from '../services/groupsPlaceApi.js'
import {mdbCard, mdbCardBody, mdbCardHeader, mdbCardText, mdbCardTitle, mdbCol, mdbContainer, mdbRow} from 'mdbvue';

export default {
  name: 'Documents',
  components: {
    mdbContainer,
    mdbCard,
    mdbCardHeader,
    mdbCardBody,
    mdbCardTitle,
    mdbCardText,
    mdbRow,
    mdbCol
  },
  computed: {
    language() {
      return this.$store.state.language
    },
  },
  watch: {
    language: function(n,o) {
      if (n != "undefined" && n!= undefined && n != this.loadedLanguage) this.loadPage()
    }
  },
  data() {
    return {
      docData: [],
      loadedLang: null
    }
  },
  mounted() {
    this.loadPage()
  },
  methods: {
    loadPage() {
      this.$store.dispatch("setExecuting", false)
      let url = "/public/page/" + this.$route.params.id
      if (this.language) {
        url += "?lang=" + this.language
        this.loadedLanguage = this.language
      }
      else this.loadedLanguage = "en"

      api.get(url).then(
        (results) => {
          this.docData = results.data
        },
        (error) => {
          if (error.response.status == 404) this.$router.push({path: '/404', query: {redirect: this.$route.fullPath}})
          else this.$notify.error({message: "Error fetching page.", timeOut: 5000})
        }).then(() => {
        this.$store.dispatch("setExecuting", false)
      })
    }
  }
};
</script>
